import { WidgetAppearance } from "@/components/widget-appearance";
import { WidgetPositioning } from "@/components/widget-positioning";
import { LivePreview } from "@/components/preview/live-preview";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { __ } from "@/i18n";
import { WidgetPublish } from "../widget-publish";

export const CustomizeTab = () => {
  return (
    <div className="cy:max-w-7xl cy:mx-auto cy:px-4 cy:sm:px-6 cy:lg:px-8 cy:pt-8">
      <Card className="cy:rounded-lg cy:shadow-none!">
        <CardHeader className="cy:border-b cy:border-gray-200 cy:pb-6">
          <CardTitle className="cy:text-xl">{__( 'Widget customisation', 'accessibility-widget' )}</CardTitle>
          <CardDescription>{__( 'Set the look and feel of your accessibility widget to align with your website.', 'accessibility-widget' )}</CardDescription>
          <CardAction><WidgetPublish /> </CardAction>
        </CardHeader>
        <CardContent className="cy:p-0">
          <div className="cy:max-w-7xl cy:mx-auto cy:px-4 cy:sm:px-6 cy:lg:px-8">
            <div className="cy:grid cy:grid-cols-1 cy:lg:grid-cols-3 cy:gap-4">
              {/* Main Configuration Panel */}
              <div className="cy:lg:col-span-2 cy:space-y-6">
                <WidgetAppearance />
                <WidgetPositioning />
              </div>

              {/* Live Preview Panel */}
              <div className="cy:lg:col-span-1 cy:py-6 cy:px-4 cy:bg-[#F1F6FD]">
                <LivePreview />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
